// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"css-2VTD600F4-","button__fullWidth":"css-3w24brvtB9","button__outlineHover":"css-1YgvON5_ql"};